/* eslint-disable @typescript-eslint/no-floating-promises */
import axios from "axios";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

/**
 * 管理员角色守卫
 * 用于判断当前用户是否有管理员权限
 * 如果没有管理员权限，则重定向到首页
 */
export const AdminRoleGuard = () => {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminRole = async () => {
      try {
        // 调用后端接口检查是否为管理员
        await axios.get("/api/v1/feedback/admin/check-role");
        setIsAdmin(true);
      } catch {
        // 如果接口返回错误，说明不是管理员
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminRole();
  }, []);

  // 加载中显示空内容
  if (loading) return null;

  // 如果是管理员，则允许访问
  if (isAdmin) {
    return <Outlet />;
  }

  // 如果不是管理员，则重定向到首页
  return <Navigate replace to="/" />;
};
